import { render, staticRenderFns } from "./AddChapterDialog.vue?vue&type=template&id=677e13f4&scoped=true"
import script from "./AddChapterDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AddChapterDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddChapterDialog.vue?vue&type=style&index=0&id=677e13f4&prod&scoped=true&lang=css"
import style1 from "./AddChapterDialog.vue?vue&type=style&index=1&id=677e13f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677e13f4",
  null
  
)

export default component.exports